const scents = [
  { name: "Lavender", color: "#B39DDB" },
  { name: "Pineapple", color: "#F2C14E" },
  { name: "Coconut", color: "#F5EBDC" },
  { name: "Lemon", color: "#F4D35E" },
  { name: "Frankincense", color: "#C79B6B" },
  { name: "Grapefruit", color: "#F19881" },
  { name: "Cookies & Vanilla", color: "#D9B382" },
  { name: "Sandalwood", color: "#8B5E3C" },
  { name: "Green Apple", color: "#8FBF64" },
  { name: "Strawberry", color: "#D5525E" },
  { name: "Peach", color: "#F0AC8B" },
  { name: "Blueberry Maple Pancakes", color: "#5F71A1" },
  { name: "Teakwood", color: "#6B4A2B" },
  { name: "Rosemary", color: "#6E8E5C" },
];

export default function ScentCollection() {
  return (
    <section
      data-testid="scent-collection-section"
      id="scents"
      className="relative bg-brand-parchment py-24 lg:py-28 overflow-hidden"
    >
      <img
        src="/assets/flower_cosmos.png"
        alt=""
        aria-hidden="true"
        className="absolute -top-4 right-0 w-56 lg:w-72 opacity-80 animate-float-slow pointer-events-none hidden md:block"
      />
      <img
        src="/assets/flower_rose.png"
        alt=""
        aria-hidden="true"
        className="absolute -bottom-4 -left-4 w-56 lg:w-72 opacity-80 animate-drift pointer-events-none hidden md:block"
      />

      <div className="relative max-w-6xl mx-auto px-6 lg:px-12 text-center z-10">
        <span className="text-xs uppercase tracking-[0.4em] text-[#B7574E]">
          Our Scent Collection
        </span>
        <h2 className="mt-4 font-serif text-4xl lg:text-5xl text-brand-moss leading-tight">
          Fourteen scents. <span className="italic">One quiet mood at a time.</span>
        </h2>
        <p className="mt-5 text-lg text-brand-ink/75 max-w-2xl mx-auto">
          Every candle in the collection is small-batch, clean-burning, and built around a single
          feeling. Members swap scents in their monthly box any time before the pour date.
        </p>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {scents.map((s) => (
            <div
              key={s.name}
              data-testid={`scent-${s.name.toLowerCase().replace(/\s+&\s+|\s+/g, "-")}`}
              className="group flex items-center gap-4 bg-brand-cream border border-brand-moss/10 rounded-2xl px-5 py-4 hover:-translate-y-1 hover:shadow-lg transition-all"
            >
              <span
                className="flex-shrink-0 w-10 h-10 rounded-full ring-4 ring-brand-cream shadow-inner"
                style={{ backgroundColor: s.color }}
              />
              <span className="text-left text-sm text-brand-moss font-serif tracking-tight leading-tight">
                {s.name}
              </span>
            </div>
          ))}
        </div>

        <p className="mt-14 font-script text-3xl text-[#B7574E]">
          Cultivating Beauty. Inspiring Wellness. <span className="text-brand-gold">♡</span>
        </p>
      </div>
    </section>
  );
}
